// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FocusIconSignature {
  Element: SVGSVGElement;
}

export const FocusIcon: TOC<FocusIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6 5H3V8H1V5C1 3.896 1.896 3 3 3H6V5ZM18 3H21C22.104 3 23 3.896 23 5V8H21V5H18V3ZM6 21V19H3V16H1V19C1 20.104 1.896 21 3 21H6ZM18 19H21V16H23V19C23 20.104 22.104 21 21 21H18V19ZM5 17H19V7H5V17ZM17 9H7V15H17V9Z"/>
</svg>
</template>;